// #region Basket

// #region Coupon
function UseCoupon(CouponCode, callback) {
    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: getRequestRoute() + "/p/CheckOutCart/AddCoupon?couponCode=" + CouponCode,
        async: true,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($(".js-coupon-form"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".js-coupon-form"), "hide");
        },
        success: function (dt) {
            callback(dt.Status, dt.ResultDescription);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function DeleteUserCoupon() {
    $.ajax({
        type: 'post',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: getRequestRoute() + '/p/CheckOutCart/RemoveCoupon',
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(false);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}
// #endregion

// #region GiftPackage
function SetGift(wantGift, callback) {
    $.ajax({
        type: 'POST',
        url: getRequestRoute() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
        cache: false,
        async: false,
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
                callback(wantGift);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                callback(false);
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            callback(false);
        }
    });
}

function GiftPackageControl() {
    var wantGift = $("#GiftPackageChk").prop("checked");

    if (wantGift == true) {
        SetGift(wantGift);
    }
}
// #endregion

// #region BasketItems
function UpdateCartAmount(BasketID, Amount, LangID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/UpdateCartAmount",
        data: 'id=' + BasketID + "&adet=" + Amount + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        cahce: false,
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true && dt.Deger8 != null) {
                var dataLayerObj = JSON.parse(dt.Deger8);

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    "event": "add_to_cart",
                    "ecommerce": {
                        "currency": "TRY",
                        "value": dataLayerObj.price,
                        "items": [dataLayerObj]
                    }
                });
            }

            callback(dt.Sonuc, dt.IslemSonucAciklama);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function RemoveFromCart(BasketID, LangID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/Cart/RemoveFromCart',
        data: 'id=' + BasketID + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        cache: false,
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true && dt.JsonRs) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    "event": "eec.remove",
                    "ecommerce": {
                        "remove": {
                            "actionField": {
                                "list": "Product Detail"
                            },
                            "products": [JSON.parse(dt.JsonRs)]
                        }
                    }
                });
            }

            callback(dt.Sonuc, dt.IslemSonucAciklama);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function CheckUserLoginForUserInfoObj() {

    if (window.userInformation == undefined) {

        $.ajax({
            type: 'GET',
            url: getRequestRoute() + '/p/Home/CheckUserLoginForUserInfoObj',
            cache: false,
            dataType: 'json',
            success: function (dt) {
                if (dt.success && dt.data != undefined) {

                    window.userInformation = dt.data;
                }
            }
        });
    }
}

function RefreshRevotasCartData() {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/Checkout/RefreshRevotasCartData',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        cache: false,
        async: false,
        success: function (dt) {
            if (dt != null && dt.data.length > 0 && RvstData) {
                RvstData.count = dt.quantity;
                RvstData.email = dt.email // Kullanıcı Email Adresı
                RvstData.oAmt = 0; // Toplam Tutar sipariş sayfasında doldurulacaktır.
                RvstData.oID = ""; // Sipariş ID, sipariş sayfasında doldurulacaktır.
                RvstData.product = dt.data;
                RvstData.status = "cart";
                localStorage.setItem('ProductData', JSON.stringify(RvstData.product));
                localStorage.setItem('RvstDataCount', dt.quantity);
            } else {
                RvstData = {};
                localStorage.removeItem("ProductData");
                localStorage.removeItem("RvstDataCount");
            }

        },
        error: function () {
            RvstData = {};//boş kalsın
            localStorage.removeItem("ProductData");
            localStorage.removeItem("RvstDataCount");
        }
    });
}

function GetBasketItems() {
    GenerateLocalLoading($(".shopping-cart-wrapper"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/Checkout/basket',
        dataType: 'html',
        cache: false,
        async: true,
        success: function (dt) {
            $(".js-cart-items-wrapper").html(dt);
        },
        complete: function () {
            GenerateLocalLoading($(".shopping-cart-wrapper"), "hide");
        }
    });
}
// #endregion

// #endregion

// #region Login

function SetMemberless(callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/CheckoutValidation/SetMemberless?memberless=true",
        cache: false,
        async: true,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            if (dt.Status == true) {
                callback(dt.Status, dt);
            }
            else {
                callback(dt.Status, dt.ResultDescription);
            }
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function LoginRegisterFormSubmit(form) {
    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "show");

    $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        success: function (dt) {
            if (dt.Sonuc == true) {
                if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                    document.location = $("#register_FbRedirectUrl").val();
                }

                if (dt.JsonRs == "Reload" || dt.JsonRs == "Redirect") {
                    document.location.reload();
                }
                else {
                    var fireObject = SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");

                    $("#LoginRegisterModal .ForgettenForm").trigger("reset");
                    $("#LoginRegisterModal .ForgettenForm .btn-cancel").trigger("click");
                    
                    if (dt.JsonRs == "ConfirmMail") {
                        fireObject.then(function (result) {
                            document.location.reload();
                        });
                    }
                }
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
        }
    });
}

// #endregion

function SetContactDetails(form, callback) {
    var disabledElements = form.find(':input:disabled').removeAttr('disabled');
    var serializedData = form.serialize();
    disabledElements.attr('disabled', 'disabled');

    $.ajax({
        type: 'POST',
        url: getRequestRoute() + "/p/CheckoutPayment/SetContactDetails",
        cache: false,
        async: true,
        data: serializedData,
        beforeSend: function () {
            GenerateLocalLoading($(".js-checkout-summary"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".js-checkout-summary"), "hide");
        },
        success: function (dt) {
            if (dt.Status == true) {
                callback(dt.Status, dt);
            }
            else {
                callback(dt.Status, dt.ResultDescription);
            }
        },
        error: function () {
            callback(false, getStandartMessages("IslemBasarisiz"));
        }
    });
}

// #region Delivery
function GetPartialAdress(AddressModal, EditLink) {
    if (EditLink == "" || EditLink == null || EditLink == undefined) {
        EditLink = getRequestRoute() + "/p/CheckOutAddress/EditOrCreate";
        AddressModal.find(".modal-header > .edit").hide();
        AddressModal.find(".modal-header > .create").show();
    }
    else {
        AddressModal.find(".modal-header > .edit").show();
        AddressModal.find(".modal-header > .create").hide();
    }

    $.ajax({
        type: "GET",
        url: EditLink,
        success: function (data) {
            AddressModal.find(".modal-body").html(data);

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                $(".tr_group").show();
                $(".stateDiv").hide();
                $(".cityDiv").hide();
            }

            if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                $(".tr_group").hide();
                $(".stateDiv").hide();
                $(".cityDiv").show();
            }

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                ||
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                $(".tr_group").hide();
                $(".stateDiv").show();
                $(".cityDiv").show();
            }

            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            AddressModal.modal("hide");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        }
    });
}

function PartialAddress(addressId, item, isBilling, callback) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/CheckOutAddress/EditOrCreate?id=" + addressId,
        async: true,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (data) {
            callback(true, data, isBilling, item);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"), false, null);
        }
    });
}

function AddressFormSubmit(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: getRequestRoute() + '/p/CheckoutAddress/EditOrCreate',
        data: form.serialize(),
        dataType: 'json',
        async: true,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (data) {
            if (data.Status) {
                callback(data.Status, data);
            }
            else {
                callback(data.Status, data.ResultDescription);
            }
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function SetAddress(id, addressType, isAllSelected, callback) {
    $.ajax({
        type: 'POST',
        url: getRequestRoute() + "/p/CheckOutAddress/SetAddress?addressID=" + id + "&addressType=" + addressType + "&UpdateAllAddress=" + isAllSelected,
        cache: false,
        async: true,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            callback(dt.Status, dt);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function GetStateCity(StateID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/User/GetStateCities',
        data: 'stateid=' + StateID,
        dataType: 'json',
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            callback(true, dt);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function GetDistrict(CityID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/User/GetTowns',
        data: 'cityid=' + CityID,
        dataType: 'json',
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            callback(true, dt);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function SetCargoPrice(id, callback) {
    $.ajax({
        type: 'post',
        url: getRequestRoute() + "/p/CheckoutAddress/SetCargoPrice?cargoPriceID=" + id,
        cache: false,
        async: true,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            if (dt.Status)
                callback(true, dt);
            else
                callback(false, dt.ResultDescription[0]);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}
// #endregion

// #region Payment

function SetPaymentType(webPosInstallmentID, BankID) {
    if (BankID == undefined) { BankID = 0; }

    $.ajax({
        type: 'POST',
        url: getRequestRoute() + "/p/CheckOutPayment/SetPaymentType?webPosInstallmentID=" + webPosInstallmentID + "&bankID=" + BankID,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt.Status) {
                RefreshOrderSummary(false);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

// #region Credit Card
function CheckBinNumber(CardNo) {
    var t = CardNo.replace(/\D/g, '');

    if (t.length >= 8) {
        var tval8 = t.substring(0, 8);
        var lastBin = tval8;

        if (lastBin != firstBin) {
            GetCardDetails(tval8);
            firstBin = lastBin;
        }
    }
}

function GetCardDetails(BinNo) {
    if (BinNo) {
        $.ajax({
            type: 'GET',
            url: getRequestRoute() + "/p/CheckoutPayment/CardDetails",
            dataType: 'json',
            async: true,
            data: "BinNo=" + BinNo,
            success: function (jsonReturn) {
                if (jsonReturn.length !== 0) {

                    $.each(jsonReturn, function (index, element) {

                        var bnkCode = element.BankCode;
                        var cardType = element.CardType;
                        var cardName = element.CardName;
                        var allowInstallment = element.AllowInstallment;

                        ShowInstallments(bnkCode, cardType, cardName, allowInstallment);
                    });
                }
                else {
                    ShowInstallments(-1, "credit");
                }
            }
        });
    }
}

function ShowInstallments(bankCode, cardType, CardName, allowInstallment) {
    if (bankCode != -1) {
        cardType = cardType.toLowerCase();
        var activeCls = "";

        switch (cardType) {
            case "credit":
                activeCls = "KrediKarti";
                break;
            case "debit":
                activeCls = "DebitCard";
                break;
        }

        var cardown = $("#CardOwner:first").val();
        var isAmex = false;
        var isShopAndMiles = false;

        if (CardName != null && CardName != "" && CardName != undefined && CardName.length > 0) {

            if (CardName.toUpperCase().indexOf("AMEX") > -1) {
                isAmex = true;
            }

            if (CardName.toUpperCase().indexOf("MASTER SM") > -1 || CardName.toUpperCase().indexOf("VISA SM") > -1) {
                isShopAndMiles = true;
            }
        }

        if (isAmex || isShopAndMiles) bankCode = "64"; //burda hangi banka gelmeli belirlenmeli

        InstallmentRows = $(".js-instalment-table tbody tr");
        InstallmentRows.removeClass("IsPasive").removeClass("IsActive");
        InstallmentRows.addClass("IsPasive");

        //alert("cardType: " + cardType);
        //alert("allowInstallment: " + allowInstallment);

        //banka kartı tek çekim olarak gösterilecektir.
        if (cardType == "debit" || allowInstallment == false) {

            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }
        //kredi kartı tek çekim olanları gösterecek.
        else if (cardType == "credit" && allowInstallment == false) {

            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }
        //kredi kartı tüm taksitleri gösterecek.
        else if (cardType == "credit") {
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }
        //herhangi bir durumda default pos taksit (Tek çekim) gösterilecektir.
        else {
            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }
    }
}
// #endregion

// #endregion



function PrepareAddressAndPayment(curStep) {
    if (curStep != null && curStep != "" && curStep != undefined) {
        var url = "";

        if (curStep == "Sepet") {
            url = getRequestRoute() + "/p/CheckOutAddress/PrepareUserAdresses";
        }
        else if (curStep == "Adres") {
            url = getRequestRoute() + "/p/CheckOutPayment/PreparePayment";
        }

        if (url.length > 0) {
            $.ajax({
                type: 'POST',
                url: url,
                success: function (dt) {
                }
            });
        }
    }
}

function SetStep(adim, callback) {
    $.ajax({
        type: 'POST',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/CheckoutValidation/SetStep?step=" + adim,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            ReloadOnTimeOut();
            callback(dt.Status, dt);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function SetCreditCartAndStep(adim) {
    if ($(".js-credit-card-form").length > 0) {
        var form = $(".js-credit-card-form");

        $.ajax({
            type: 'POST',
            async: true,
            cache: false,
            url: getRequestRoute() + "/p/CheckoutPayment/SetCreditCard",
            data: form.serialize(),
            beforeSend: function () {
                GenerateLocalLoading($("body"), "show");
            },
            complete: function () {
                GenerateLocalLoading($("body"), "hide");
            },
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    SetStep(adim, SetStepHandler);
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            },
            error: function () {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    }
}

function RefreshOrderSummary(animateTop) {
    $.ajax({
        type: 'GET',
        cache: false,
        url: getRequestRoute() + "/p/CheckOut/SummaryPartial",
        //beforeSend: function () {
        //    GenerateLocalLoading($(".js-checkout-summary"), "show");
        //},
        //complete: function () {
        //    GenerateLocalLoading($(".js-checkout-summary"), "hide");
        //},
        success: function (dt) {
            $(".js-checkout-summary").html(dt);

            if (animateTop && !isMobileResolution()) {
                $('html,body').animate({ scrollTop: 0 }, 'slow', function () { });
            }
        }
    });
}

function SetProgress(callback) {
    $.ajax({
        type: 'POST',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/Checkout/progress",
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt && dt.CreatedOrderID)
                callback(true, dt);
            else
                callback(false, getStandartMessages("BirHataOlustu"));
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}


function InitContactDetails(callback) {
    $.ajax({
        type: 'GET',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/CheckOut/ContactDetailsPartial",
        beforeSend: function () {
            GenerateLocalLoading($(".checkout-content"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".checkout-content"), "hide");
        },
        success: function (dt) {
            callback(dt);
        },
        error: function (dt) {
            callback(null);
        }
    });
}

function InitAddress(callback) {
    $.ajax({
        type: 'GET',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/CheckOut/AddressPartial",
        beforeSend: function () {
            GenerateLocalLoading($(".checkout-content"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".checkout-content"), "hide");
        },
        success: function (dt) {
            callback(dt);
        },
        error: function (dt) {
            callback(null);
        }
    });
}

function InitPayment(callback) {
    $.ajax({
        type: 'GET',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/CheckOut/PaymentPartial",
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            callback(dt);
        },
        error: function (dt) {
            callback(null);
        }
    });
}

function GetOrderInformation(callback) {
    $.ajax({
        type: 'GET',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/CheckOut/GetOrderInformation",
        success: function (dt) {
            callback(dt.Sonuc, dt);
        },
        error: function (dt) {
            callback(false, null);
        }
    });
}